import { Injectable } from '@angular/core';
import { StepBasicDigitalData } from '@core/models';
import { StepResolver } from '@core/models/swagger/analytics';
import { RoutePaths } from '@global/routePaths';
import { getLastLevelPath } from '@global/utils';

@Injectable({
  providedIn: 'root',
})
export class StepResolverService {
  resolveStepNumber(pageName: string, context?: Record<string, unknown>): StepResolver {
    switch (pageName) {
      /**
       * SITUATION (LAGE)
       */
      case getLastLevelPath(RoutePaths.NEW_QUOTATION.SITUATION.VERTI_CLIENT.route):
        return { stepNumber: '1', description: 'customer check', stepBasic: StepBasicDigitalData.QUOTING_START };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.SITUATION.FAMILY_SITUATION.route):
        return { stepNumber: '1.2', description: 'family situation' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.SITUATION.INSURANCE_START_DATE.route):
        return { stepNumber: '1.3', description: 'insurance begin' };

      /**
       * OFFER (ANGEBOT)
       */
      case getLastLevelPath(RoutePaths.NEW_QUOTATION.OFFER.route):
        return {
          stepNumber: '2',
          description: 'offers list',
          stepBasic: StepBasicDigitalData.PRICE_VIEW,
        };

      /**
       * CONTRACT (VERTRAG)
       */
      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_DATA.route):
        return {
          stepNumber: '3.1',
          description: 'policyholder name',
          stepBasic: StepBasicDigitalData.PURCHASING_START,
        };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_CONTACT.route):
        return { stepNumber: '3.2', description: 'policyholder contact' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_ADDRESS.route):
        return { stepNumber: '3.3', description: 'policyholder address' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.TAX_DEDUCTION_PROFESSION.route):
        return { stepNumber: '3.4', description: 'policyholder profession' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.PARTNER_DATA.route):
        return { stepNumber: '3.5', description: 'policyholder partner' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.PREVIOUS_INSURANCE.route):
        return { stepNumber: '3.6', description: 'previous insurance' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.PAYMENT.route):
        return { stepNumber: '3.7', description: 'payment account' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.SEPA.route):
        return { stepNumber: '3.8', description: 'sepa mandate' };

      /**
       * SUMMARY (ZUSAMMENFASSUNG)
       */
      case getLastLevelPath(RoutePaths.NEW_QUOTATION.SUMMARY.route):
        return { stepNumber: '4', description: 'summary page' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.SUMMARY.CONFIRMATION.route):
        return { stepNumber: '4', description: 'summary page' };

      /**
       * SUCCESS / ERROR
       */
      case getLastLevelPath(RoutePaths.NEW_QUOTATION.THANK_YOU.route):
        return {
          stepNumber: '5',
          description: 'thank you page',
          stepBasic: StepBasicDigitalData.PURCHASING_END,
        };

      case getLastLevelPath(RoutePaths.GENERIC_ERROR.route):
        return { stepNumber: '99', description: 'generic error' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.CONTRACT.BAD_CLIENT.route):
        return { stepNumber: '98', description: 'bad client error' };

      case getLastLevelPath(RoutePaths.NEW_QUOTATION.SUMMARY.KO.route):
        return { stepNumber: '97', description: 'bad request error' };

      default:
        return { stepNumber: '', description: 'unknown_step' };
    }
  }
}
